var map = {
	"./degiro-dark.png": "d035",
	"./financial-times-screener-dark.png": "c943",
	"./ibkr-dark.png": "b416",
	"./ing-dark.png": "d1e8",
	"./myinvestor-dark.png": "7728",
	"./renta4-dark.png": "7986",
	"./seeking-alpha-dark.png": "56d1",
	"./tikr-dark.png": "7904",
	"./trading-view-dark.png": "c03f"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "54e3";